import { Component, OnDestroy, ElementRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription, Subject, Observable } from "rxjs";

import { BfxDialogData } from "./models/bfx-dialog-data.model";
import { BfxDialogCommand } from "./models/bfx-dialog-command.enum";
import { DashboardItemType } from "../bfx-common/models/dashboard-item-type.enum";
import { GoldenLayoutAdditionMode } from "../golden-layout/golden-layout-addition-mode";

import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";
import { BfxOrderCancelComponent } from "../bfx-order-cancel/bfx-order-cancel.component";

import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";
import { BfxTradeDialogsProcessorService } from "./services/bfx-trade-dialogs-processor.service";
import {
  GoldenLayoutService,
  GLPopoutConfiguration,
  GLPopoutState,
  GLPopoutUndockBehaviour,
} from "../golden-layout/golden-layout-service";
import {
  OrdersTableDefinitionFactory,
  TableDefinition,
  COLUMN_TARGET_DESK_ID,
} from "shared/cubiq-services";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxDialogConfirmComponent } from "./bfx-dialog-confirm.component";
import { BfxOrderDialogsProcessorService } from "./services/bfx-order-dialogs-processor.service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: `bfx-dialog-tolerance`,
  templateUrl: `./html/bfx-dialog-tolerance.html`,
  standalone: false,
})
export class BfxDialogToleranceComponent extends BfxDialogConfirmComponent {
  constructor(
    protected layoutService: GoldenLayoutService,
    protected translationService: TranslateService,
    ordersTableDefinitionFactory: OrdersTableDefinitionFactory,
    private _orderDialogProcessorService: BfxOrderDialogsProcessorService,
    private myElement: ElementRef,
  ) {
    super(layoutService, translationService, ordersTableDefinitionFactory, myElement);
    this.data.dialogData["checkbox_template"] = {
      enabled: "STP Enabled",
      disabled: "STP Disabled",
    };
  }

  public openDialog(_dialogData: BfxDialogData): Observable<any> {
    let obs = super.openDialog(_dialogData);

    // evaluate for STP checkbox and assign values
    this._orderDialogProcessorService
      .evaluateSTPCheckboxState(_dialogData.event)
      .then((stpState) => {
        this.assignValuesAndShowConfirmDialog(stpState.show, stpState.state, stpState.disabled);
      });

    return obs;
  }

  private assignValuesAndShowConfirmDialog(
    checkbox_show: boolean,
    checkbox_state: boolean,
    checkbox_disabled: boolean,
  ): void {
    this.data.dialogData.checkbox_show = checkbox_show;
    this.data.dialogData.checkbox_state = checkbox_state;
    this.data.dialogData.checkbox_disabled = checkbox_disabled;
    this.data.dialogData.checkbox_text = checkbox_state
      ? this.data.dialogData.checkbox_template.enabled
      : this.data.dialogData.checkbox_template.disabled;
  }

  public onChangeQuickFillConfirm_checkbox(): void {
    if (this.data.dialogData.checkbox_state) {
      this.data.dialogData.checkbox_text = this.data.dialogData.checkbox_template.enabled;
    } else {
      this.data.dialogData.checkbox_text = this.data.dialogData.checkbox_template.disabled;
    }
  }

  public actionConfirmed(): void {
    this.confirmed = true;
    if (this.data.payload.isQuickFill) {
      this.data.payload.callback(this.data.actionEvent, this.data.dialogData.checkbox_state);
    } else {
      this.data.payload.callback(this.data.actionEvent);
    }
    this.closeDialog();
  }
}
